import { defineMessages } from 'react-intl';

const messages = defineMessages({
  heroTitle: { id: 'modules-default-landingReferral-heroTitle' },
  heroDescription: { id: 'modules-default-landingReferral-heroDescription' },
});

export default messages;
